// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Page, { PageProps } from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@tps/App/Components/Common/XngZone";
import { XngCustomGroup } from "@tps/XDL/constants";
import * as React from "react";

interface Props extends WidgetProps {}

interface EspotAndTestimonialsContainerStyles {
    wrapper?: InjectableCss;
    leftSection?: InjectableCss;
    rightSection?: InjectableCss;
    container?: InjectableCss;
    page?: PageProps;
}

export const espotAndTestimonialsContainerStyles: EspotAndTestimonialsContainerStyles = {};
const styles = espotAndTestimonialsContainerStyles;

const EspotAndTestimonialsContainer: React.FunctionComponent<Props> = (props: Props) => {
    const { id } = props;

    return (
        <StyledWrapper {...styles.container}>
            <Page {...styles.page} as="div">
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.leftSection}>
                        <XngZone contentId={id} zoneName="Content00" hint="Zone For Testimonials" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.rightSection}>
                        <XngZone contentId={id} zoneName="Content01" hint="Zone For Espot" />
                    </StyledWrapper>
                </StyledWrapper>
            </Page>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: EspotAndTestimonialsContainer,
    definition: {
        group: XngCustomGroup,
        fieldDefinitions: [],
    },
};

export default widgetModule;
